<template>
  <transition-group name='list' tag='ul' class='toasts'>
    <li v-for='toast in toasts' :key='toast.id' :class='["toast", toast.type]'>
      {{ toast.message }}
    </li>
  </transition-group>
</template>

<script>
export default {
  name: 'TheToast',

  computed: {
    toasts () {
      return this.$store.state.toasts
    }
  }
}
</script>
